import { core } from '@musinsa/pbo-core'

interface Props {
  open: boolean
  /** 무엇이 막혔는지 — 저장과 확정이 같은 응답을 쓰므로 제목을 고정하면 확정 실패에 "저장 실패" 가 뜬다. */
  title: string
  message: string
  barcodes: string[]
  onClose: () => void
}

/**
 * SKU 미해소 차단 안내 (LOGISPRD-10932 · 10947).
 *
 * 저장·확정 모두 SKU 를 못 채우면 422 + `failedBarcodes` 로 막힌다. 막힌 바코드는 담당자가 SCM Hub 에
 * 등록할 목록이라 잘라 보여주지 않는다. 그래서 alert 가 아니라 스크롤되는 모달이다(1.0 SkuFailModal 파리티).
 */
export function SkuFailModal({ open, title, message, barcodes, onClose }: Readonly<Props>) {
  return (
    // core.Modal(신규 디자인) — 옛 루트 export Modal(레거시, 취소 버튼을 숨길 수 없었다) 대신. 안내 모달이라 버튼은 [확인] 하나다.
    <core.Modal
      open={open}
      title={title}
      width={520}
      onCancel={onClose}
      footer={
        <core.Button type="primary" onClick={onClose}>
          확인
        </core.Button>
      }
    >
      <core.Typography.Text>{message}</core.Typography.Text>
      {barcodes.length > 0 && (
        <div
          style={{
            marginTop: 12,
            maxHeight: 280,
            overflowY: 'auto',
            border: '1px solid #f0f0f0',
            borderRadius: 4,
            padding: '8px 12px',
          }}
        >
          {/* 같은 바코드가 여러 행에 쓰이면 목록에도 중복이 올 수 있어 인덱스를 키에 섞는다. */}
          {barcodes.map((barcode, index) => (
            <div key={`${barcode}-${index}`} style={{ fontSize: 13, lineHeight: '22px' }}>
              {barcode}
            </div>
          ))}
        </div>
      )}
    </core.Modal>
  )
}

export default SkuFailModal
